<template>
  <div>
    <div>
      <p class="title">预约信息</p>
      <table class="c-talbe">
        <tr>
          <td class="text-right" width="150">预约日期</td>
          <td v-if="pavilion">{{ pavilionAppoint.planDate }}</td>
        </tr>
        <tr>
          <td class="text-right" width="150">预约时间</td>
          <td v-if="pavilion">{{ pavilionAppointArr[0].startTime + '-' + pavilionAppointArr[1].endTime }}</td>
        </tr>
        <tr>
          <td class="text-right">预约地点</td>
          <td v-if="pavilion">{{ pavilion.pavilionPlace }}</td>
        </tr>
        <tr>
          <td class="text-right">面试亭</td>
          <td v-if="pavilion">{{ pavilion.pavilionName }}</td>
        </tr>
        <tr>
          <td class="text-right"/>
          <td v-if="pavilion">
            <el-avatar
              shape="square"
              :size="90"
              :src="pavilion.imgUrl"
            />
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>

import QrcodeVue from "qrcode.vue";

export default {
  components: {QrcodeVue},
  props: {
    pavilion: {},
    pavilionAppointArr: [],
    pavilionAppoint: {}
  },
  data() {
    return {
      fullscreen: true,
      pavilionQRDialog: false,
      windowInnerWidth: 0
    }
  },
  created() {
    this.windowInnerWidth = window.innerWidth
  }
};
</script>
<style scoped>
.title {
  width: 100%;
  padding: 10px;
  background-color: rgb(198, 212, 248);
  text-align: center;
  font-weight: bold;
  margin: 10px 0;
}

.c-talbe {
  display: table-cell;
  width: 100%;
}

.c-talbe td {
  padding: 5px;
}

p {
  line-height: 24px;
}

tr td:nth-child(2) {
  font-weight: bolder;
}
</style>
